import React, { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { trackEvent } from "../lib/tracker";
import { findSub } from "../lib/services";

/**
 * Fires a page_view event on every route change. Reads sub-service code from
 * the URL when on /service/:serviceSlug/:subSlug so sales can see exactly
 * which product each lead is looking at.
 */
export default function ActivityTracker() {
  const location = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    // Only track authenticated studio pages + admin login page.
    // Skip admin console pages so admin browsing doesn't pollute lead data.
    const path = location.pathname;
    if (path.startsWith("/admin") && path !== "/admin/login") return;
    if (path === lastPathRef.current) return;
    lastPathRef.current = path;

    let serviceCode = "";
    let subCode = "";
    const m = path.match(/^\/service\/([^/]+)(?:\/([^/]+))?/);
    if (m) {
      const svcSlug = m[1];
      const subSlug = m[2];
      if (subSlug) {
        const { service, sub } = findSub(svcSlug, subSlug);
        if (service) serviceCode = service.id;
        if (sub) subCode = sub.code;
      }
    }

    trackEvent({
      eventType: "page_view",
      path,
      url: window.location.href,
      pageTitle: document.title,
      serviceCode,
      subCode,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
